import React from "react";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import { Tooltip } from "components/common/Tooltip";
import { useOrgContextStore } from "@/components/main/stores/orgContextStore";

export const OrgBadge: React.FC = () => {
  const org = useOrgContextStore((s) =>
    s.orgs.find((o) => o.org_id === s.activeOrgId),
  );
  if (!org) return null;
  const personal = org.is_personal;
  const Icon = personal ? PersonOutlineOutlinedIcon : CorporateFareOutlinedIcon;
  return (
    <Tooltip title={personal ? "Personal organization" : "Organization"}>
      <span
        className={`inline-flex items-center gap-1 h-6 px-2 rounded-app border text-small font-medium whitespace-nowrap ${
          personal
            ? "border-border text-fg-muted bg-bg-subtle"
            : "border-[color-mix(in_srgb,var(--color-accent)_45%,transparent)] text-accent bg-accent-15"
        }`}
      >
        <Icon className="icon-sm" />
        {personal ? "Personal" : org.name}
      </span>
    </Tooltip>
  );
};
